"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BatteryConnect = void 0;
var React = _interopRequireWildcard(require("react"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var BatteryConnect = function BatteryConnect(props) {
  var percent = props.percent;
  var fillSvg = null;
  if (0 <= percent && percent <= 19) {}
  if (20 <= percent && percent <= 39) {
    fillSvg = /*#__PURE__*/React.createElement("path", {
      d: "M3.87402 10.5528C3.87402 9.63348 4.61785 8.88747 5.53717 8.88478L7.20113 8.8799C8.12427 8.8772 8.87405 9.62479 8.87405 10.5479V13.4618C8.87405 14.3812 8.13022 15.1272 7.2109 15.1299L5.54695 15.1347C4.62381 15.1375 3.87402 14.3899 3.87402 13.4667V10.5528Z",
      fill: "#0095E0"
    });
  }
  if (40 <= percent && percent <= 59) {
    fillSvg = /*#__PURE__*/React.createElement("path", {
      d: "M3.87402 10.555C3.87402 9.63479 4.61917 8.88843 5.53933 8.88693L11.1611 8.87773C12.0834 8.87622 12.8319 9.62347 12.8319 10.5458V13.4597C12.8319 14.3799 12.0867 15.1262 11.1666 15.1277L5.54479 15.1369C4.62249 15.1384 3.87402 14.3912 3.87402 13.4689V10.555Z",
      fill: "#0095E0"
    });
  }
  if (60 <= percent && percent <= 80) {
    fillSvg = /*#__PURE__*/React.createElement("path", {
      d: "M3.87402 10.5556C3.87402 9.6352 4.61958 8.88873 5.54 8.88759L14.079 8.87706C15.001 8.87592 15.7491 9.62306 15.7491 10.5451V13.459C15.7491 14.3794 15.0035 15.1259 14.0831 15.1271L5.54412 15.1376C4.62208 15.1387 3.87402 14.3916 3.87402 13.4696V10.5556Z",
      fill: "#0095E0"
    });
  }
  if (81 <= percent && percent <= 100) {
    fillSvg = /*#__PURE__*/React.createElement("path", {
      d: "M3.87402 10.556C3.87402 9.63542 4.61979 8.88889 5.54036 8.88795L16.5794 8.8767C17.5013 8.87576 18.2491 9.62284 18.2491 10.5447V13.4587C18.2491 14.3792 17.5033 15.1258 16.5828 15.1267L5.54376 15.1379C4.62187 15.1389 3.87402 14.3918 3.87402 13.4699V10.556Z",
      fill: "#0095E0"
    });
  }
  return /*#__PURE__*/React.createElement(_SvgIcon.default, _extends({}, props, {
    viewBox: "0 0 24 24"
  }), fillSvg, /*#__PURE__*/React.createElement("rect", {
    x: "2.66567",
    y: "7.66665",
    width: "16.9991",
    height: "8.6667",
    rx: "2.6666",
    stroke: "#0095E0",
    strokeWidth: "1.3333",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4533 12.1676C22.4533 13.1308 22.0359 13.5373 21.6835 13.7089C21.4352 13.8299 21.2034 13.6105 21.2034 13.3343V11.001C21.2034 10.7248 21.4352 10.5054 21.6835 10.6263C22.0359 10.798 22.4533 11.2045 22.4533 12.1676Z",
    fill: "#0095E0"
  }));
};
exports.BatteryConnect = BatteryConnect;